import { Select } from "antd";
import { useGetAllShiftPoliciesQuery } from "AppQuries/shift/policy/shift-policy";

import PropTypes from "prop-types";
import React, { useMemo } from "react";
import { useFormContext, useWatch, Controller } from "react-hook-form";

const ShiftController = ({
  handleUpdateAttendance,
  setTotalWorkingHours,
  shiftOptions,
  shifts,
  id,
  isDisabled,
}) => {
  const { setValue, watch, control } = useFormContext();

  const companyCode = useWatch({ name: "companyCode" });
  const locationCode = useWatch({ name: "locationCode" });
  const inTime = useWatch({ name: `attendance[${id}].inTime` });
  const outTime = useWatch({ name: `attendance[${id}].outTime` });
  const shiftName = watch(`attendance[${id}].shiftName`); // useWatch({ name: `attendance[${id}].shiftName` });
  const shiftCode = watch(`attendance[${id}].shiftCode`); // useWatch({ name: `attendance[${id}].shiftCode` });
  const setShift = (id, shift) => {

    const selectedShift = shifts.find((s) => s.shiftPolicyID === Number(shift));



    const [hours1, minutes1] = selectedShift?.shiftStartTime.split(":") ?? [
      "00",
      "00",
    ];
    const [hours2, minutes2] = selectedShift?.shiftEndTime.split(":") ?? [
      "00",
      "00",
    ];

    const date1 = new Date();
    date1.setHours(+hours1, +minutes1, 0, 0);

    const date2 = new Date();
    date2.setHours(+hours2, +minutes2, 0, 0);

    setTotalWorkingHours(id, date1, date2);
    // setValue(`attendance[${id}].inTime`, selectedShift?.shiftStartTime);
    // setValue(`attendance[${id}].outTime`, selectedShift?.shiftEndTime);

    // For Skip In Time and Out Time when is already set
    if (inTime === "00:00:00" && outTime === "00:00:00") {
      setTotalWorkingHours(id, date1, date2);
    }

    if (inTime === "00:00:00") {
      setValue(`attendance[${id}].inTime`, selectedShift?.shiftStartTime);
    }

    if (outTime === "00:00:00" || outTime === null) {
      setValue(`attendance[${id}].outTime`, selectedShift?.shiftEndTime);
    }

    // setValue(`attendance[${id}].attendanceValue`, 1);
    setValue(`attendance[${id}].scheduleId`, 0); // no schedule logic currently
    setValue(`attendance[${id}].isCheck`, true);
    setValue(`attendance[${id}].hasOutTime`, true);
    // setValue(
    //   `attendance[${id}].isAlternateDayOff`,
    //   watch(`attendance[${id}].isAlternateDayOff`) && watch(`attendance[${id}].isHalfDay`) ? true : false,
    // );

    setValue(
      `attendance[${id}].isAlternateDayOff`,
      watch(`attendance[${id}].isAlternateDayOff`) ? true : false,
    );
    // if (
    //   watch(`attendance[${id}].remarks`) === "Rest Day" ||
    //   watch(`attendance[${id}].remarks`) === "Weekly Off"
    // ) {
    //   setValue(`attendance[${id}].remarks`, "Manual Entry");
    // }

    setValue(`attendance[${id}].mode`, "MM");
    setValue(`attendance[${id}].shiftName`, selectedShift?.shiftName);
    setValue(
      `attendance[${id}].shiftId`,
      selectedShift.shiftPolicyID.toString(),
    );

    if (watch(`attendance[${id}].isPaidLeave`) === 1) {
      setValue(`attendance[${id}].inTime`, "00:00:00");
      setValue(`attendance[${id}].outTime`, "00:00:00");
    }

    // setValue(`attendance[${id}].isAlternateDayOff`, false);

    handleUpdateAttendance(id);
  };

  // Add "None" option at the beginning of shiftOptions
  // const optionsWithNone = [
  //   { label: "None", value: "" },
  //   ...(shiftOptions?.map((s) => ({ label: s.label, value: s.value })) || []),
  // ];

  const onShiftClear = () => {
    console.log("Shift Cleared");
    // setValue(`attendance[${id}].inTime`, "00:00:00");
    // setValue(`attendance[${id}].outTime`, "00:00:00");
    // setValue(`attendance[${id}].attendanceValue`, 0);
    // setValue(`attendance[${id}].isCheck`, false);
    setValue(`attendance[${id}].shiftId`, "");
    setValue(`attendance[${id}].shiftName`, "");
    setValue(`attendance[${id}].scheduleId`, 0);
    handleUpdateAttendance(id);
  };
  return (
    <div className="form-floating">
      <Select
        name={`attendance[${id}].shiftId`}
        showSearch
        options={shiftOptions}
        placeholder="Select Shift"
        // className="form-control select-option-height"
        // value={field.value !== undefined && field.value !== "" ? field.value : undefined}defaultValue={{ label: shiftName || "" }}
        // defaultValue={{ label: shiftName || "" }}
        value={
          shiftName && shiftName !== "" ? { label: shiftName || "" } : undefined
        }
        onSelect={(value) => {
          setShift(id, value);
        }}
        size="large"
        style={{ width: "100%" }}
        filterOption={(input, option) =>
          option.label.toLowerCase().includes(input.toLowerCase())
        }
        allowClear={false}
        onClear={onShiftClear}
        dropdownStyle={{
          minWidth: "fit-content",
        }}
        disabled={isDisabled}
      />
    </div>
  );

  // return (
  // <div className="form-floating">
  // <Controller
  //   name={`attendance[${id}].shiftId`}
  //   control={control}
  //   render={({ field }) => (

  // )}
  // />
  // </div>
  // <div className="form-floating">
  // <Input
  //   name={`attendance[${id}].shiftName`}
  //   type="commonSelect2"
  //   className="form-control select-option-height"
  //   // value={{ label: shiftName || "" }}
  //   // defaultValue={{ label: shiftName || "" }}
  //   optionData={shiftOptions}
  //   labelInValue
  //   onSelect={(e) => setShift(id, e.value)}
  //   style={{ width: "150px" }}
  //   disabled={
  //     watch(`attendance[${id}].isApproved`) ||
  //     watch(`attendance[${id}].isReviewed`)
  //   }
  //   allowClear={
  //     watch(`attendance[${id}].scheduleId`) &&
  //     watch(`attendance[${id}].scheduleId`) !== 0
  //   }
  //   onClear={onShiftClear}
  //   placeholder="Select Shift"
  //   aria-placeholder="Select Shift"
  //   aria-label="Select Shift"
  // />
  // </div>
  // );
};

export default React.memo(ShiftController);

ShiftController.propTypes = {
  handleUpdateAttendance: PropTypes.func.isRequired,
  setTotalWorkingHours: PropTypes.func.isRequired,
  id: PropTypes.number.isRequired,
  shiftOptions: PropTypes.array.isRequired,
  shifts: PropTypes.array.isRequired,
  isDisabled: PropTypes.bool.isRequired,
};
